import { useCallback, useState } from 'react'

import { EMPTY_OBJECT } from '../constants/common'
import { copyHtmlWithDom } from '../utils/html'

export function useCopyToClipboard({ onError, onSuccess } = EMPTY_OBJECT) {
  const [copiedText, setCopiedText] = useState(null)

  const copy = useCallback(
    async (text, { html } = EMPTY_OBJECT) => {
      try {
        // copyHtmlWithDom must run before any await to stay within the user-gesture guard
        const htmlCopied = html ? copyHtmlWithDom(html, text) : false

        if (!htmlCopied) {
          await navigator.clipboard.writeText(text)
        }

        setCopiedText(text)

        onSuccess?.()

        return true
      } catch {
        setCopiedText(null)

        onError?.()

        return false
      }
    },
    [onError, onSuccess]
  )

  return [copiedText, copy]
}
